import { useTranslation } from 'react-i18next';
import type { IPickerProps } from './IPickerProps';
import { PickerList } from './PickerList';
import { PickerTrigger } from './PickerTrigger';
import { usePicker } from './usePicker';
import './pickers.css';

/**
 * Єдиний власний список вибору платформи (UIUX/controls/picker; прототип pickerVM): поле з крапкою й шевроном, плаваючий список
 * у порталі з пошуком понад 7 пунктів, ✓ на поточному значенні, клавіатура ↑ ↓ Enter Esc Tab, ARIA listbox/option.
 * Розміри: md 34px (форми), sm 30px, key — пігулка ключового рядка, inline — клітинка редагування в рядку.
 */
export function Picker(props: IPickerProps) {
  const { t } = useTranslation();
  const s = usePicker(props);
  const { value, options, label, size = 'md' } = props;
  const current = options.find((o) => o.value === value && o.value !== '') ?? (value ? props.selected ?? null : null);
  const activeId = s.hi >= 0 ? `${s.listId}-o${s.hi}` : undefined;
  return (
    <>
      <PickerTrigger id={props.id} buttonRef={s.trigger} listId={s.listId} open={s.open} activeId={activeId} label={label} prefix={props.prefix}
        size={size} current={current} placeholder={props.placeholder ?? t('fieldControls.notSet')} leading={props.leading}
        readOnly={props.readOnly} disabled={props.disabled} invalid={props.invalid} className={props.className} title={props.title}
        autoFocus={props.autoFocus} onToggle={s.toggle} onKeyDown={s.onKeyDown} onBlur={s.onBlur} />
      {s.open && s.pos && (
        <PickerList listId={s.listId} panelRef={s.panel} pos={s.pos} label={label} options={s.shown} value={value} hi={s.hi}
          onPick={s.pick} onHover={s.setHi} compact={size === 'key'} loading={props.loading} footer={props.footer}
          emptyText={props.emptyText ?? t('fieldControls.noMatches')}
          search={s.showSearch ? { value: s.q, onChange: s.setQuery, onKeyDown: s.onKeyDown, onBlur: s.onBlur, placeholder: t('fieldControls.search'), label: t('fieldControls.searchOptions') } : null} />
      )}
    </>
  );
}
